import AdditionalSections from './components/AdditionalSections';
import './App.css';
import Experience from './components/Experience';
import Hero from './components/Hero';
import Navbar from './components/Navbar';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Footer from './components/Footer';

function App() {
  return (
    <div className='font-leto'>
      <Navbar />
      <Hero />
      <Skills />
      <Projects />
      <Experience />
      <AdditionalSections />
      <Footer />
    </div>
  );
}

export default App;